import { LocaleHome } from '../en/home'

const home: LocaleHome = {
  pickleballGlobal: 'Hệ Thống Xếp Hạng Toàn Cầu Chính Xác Nhất của Pickleball',
  freePlayers: 'Miễn Phí cho Tất Cả Cầu Thủ',
  trustedByTheWorld:
    'Được tin tưởng bởi các câu lạc bộ Pickleball hàng đầu thế giới, các chuyến du lịch chuyên nghiệp và cả những cầu thủ giải trí.',
  ourPhilosophy: 'Triết Lý Của Chúng Tôi',
  innovateGame: 'Đổi Mới Trò Chơi.',
  unifySport: 'Thống Nhất Môn Thể Thao.',
  theMostAccurateGlobal:
    'Hệ thống xếp hạng toàn cầu chính xác nhất được tin tưởng bởi các câu lạc bộ, chuyến du lịch và chuyên gia Pickleball hàng đầu thế giới.',
  optimizedAccuracy: 'Tối Ưu Hóa Độ Chính Xác',
  yourDUPRRating: 'Xếp hạng DUPR của bạn được tính toán bởi',
  marginVictory: 'Biên Độ Chiến Thắng',
  pointsWon: '(điểm thắng)',
  typeResult: 'Loại Kết Quả',
  recreationalEtc: '(chơi giải trí so với giải đấu, giải đấu được chấp thuận, v.v.)',
  outcome: 'Kết Quả',
  winLoss: '(thắng hay thua)',
  builtPickleball: 'Xây Dựng cho Cộng Đồng Pickleball',
  builtPickleballDesc:
    'Một cộng đồng tiến bộ, bao gồm tất cả mọi người xứng đáng có một hệ thống xếp hạng phù hợp. Với DUPR, tất cả cầu thủ bất kể tuổi tác, giới tính, vị trí, hoặc kỹ năng đều được xếp hạng trên cùng một thang điểm từ 2.00-8.00.',
  whatWeDo: 'Chúng Tôi Làm Gì',
  aNewWayPlay: 'Một Cách Chơi Mới',
  aNewWayPlayDesc:
    'Hệ thống xếp hạng DUPR không bỏ lỡ bất kỳ thông tin hay dữ liệu nào. Họ kết hợp tất cả vào thuật toán của mình, làm cho nó trở thành xếp hạng chính xác nhất',
  searchTheDatabase: 'Tìm Kiếm Cơ Sở Dữ Liệu',
  searchTheDatabaseDesc: 'Duyệt cơ sở dữ liệu DUPR của hơn 1,000,000 cầu thủ pickleball.',
  findYourClub: 'Tìm Câu Lạc Bộ Của Bạn',
  findYourClubDesc: 'Theo dõi câu lạc bộ của bạn để cập nhật thông tin về các sự kiện sắp tới.',
  analyzePerformance: 'Phân Tích Hiệu Suất Của Bạn',
  analyzePerformanceDesc: 'Theo dõi tiến trình của bạn khi DUPR phân tích trò chơi của bạn.',
  logMatches: 'Ghi Chép Các Trận Đấu',
  logMatchesDesc: 'Nhập điểm số từ mọi trận đấu, bất cứ lúc nào.',
  connectLocalPlayers: 'Kết Nối với Cầu Thủ Địa Phương',
  connectLocalPlayersDesc: 'Tìm cầu thủ địa phương và lên lịch chơi.',
  events: 'Sự Kiện',
  eventsDesc: 'Thử thách kỹ năng của bạn với những đối thủ ngang tài ngang sức trong các sự kiện có thương hiệu DUPR.',
}

export default home
